import { Component } from '@angular/core';

@Component({
  selector: 'app-vision-mission',
  imports: [],
  templateUrl: './vision-mission.component.html',
  styleUrl: './vision-mission.component.css',
})
export class VisionMissionComponent {

}
